
import { Component, Prop } from 'vue-property-decorator';
import Button from '@/components/atoms/Button/Button.vue';

@Component({ components: { Button } })
export default class GhostButton extends Button {
  constructor() {
    super();
  }
}
